import * as React from 'react';

import DashboardIcon from '@mui/icons-material/Dashboard';
import ItemMenu, { ListItemMenu } from '../../components/ItemMenu';
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';
import InboxIcon from '@mui/icons-material/Inbox';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import ComputerIcon from '@mui/icons-material/Computer';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import { Divider, List } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';
import { BarChart, Description, Lan, LanOutlined, Subscriptions } from '@mui/icons-material';
import { useAuth } from '../../components/AuthProvider';
import api from '../../services/api';
import Config from './Config';
import Profile from '../profile';

export const Menu =({open})=>{
  const auth = useAuth();
  const [topologiaLiberada, setTopologiaLiberada] = React.useState(false);

  // Uma consulta por montagem do menu. Sai da conta quando o usuario nem tem a
  // permissao — nesse caso a resposta seria "nao" de qualquer forma.
  React.useEffect(() => {
    if (!auth.hasPerm("backup.get_all")) { setTopologiaLiberada(false); return; }
    api.get('/topology/habilitado')
      .then((r) => setTopologiaLiberada(!!r.data?.habilitado))
      .catch(() => setTopologiaLiberada(false));
  }, [auth]);

  return (
    <List>

        <ItemMenu icon={<DashboardIcon />}
          name="Dashboard" path="/hermes"/>
      <ItemMenu icon={<LanOutlined />} name="Hosts" path="/hermes/host" />
      <ItemMenu icon={<Description />} name="Backups" path="/hermes/backup"  />
      <ItemMenu icon={<BarChart />} name="Relatório de Erros" path="/hermes/error-backup" />
      <ItemMenu icon={<Subscriptions />} name="Fila" path="/hermes/queue"  />
      {/* Beta liberado por empresa em tb_service. A permissao sozinha nao basta
          para decidir se o item aparece: ela diz que o usuario pode ver
          topologia, nao que a EMPRESA dele tem o beta. Por isso a pergunta vai
          ao servidor — item que aparece e devolve 403 e pior que item ausente.
          O gate de verdade continua nas rotas de dados; isto e so nao prometer
          o que nao vai abrir. */}
      {topologiaLiberada &&
        <ItemMenu icon={<Lan />} name="Topologia (beta)" path="/hermes/topologia" />}
     <Divider/>
      <ItemMenu icon={<BarChart />} name="Log Auditoria" path="/hermes/audit"  />
      <Config/>
      <Profile/>
     {auth.hasPerm("role.get_all") && auth.hasPerm("user.get_all") &&
      <ListItemMenu icon={<SettingsIcon />} name={"Config"}>
        <ItemMenu icon={<GroupIcon />}
          name="Cargos" path="/hermes/role" perm="role.get_all" />
        <ItemMenu icon={<PersonIcon />}
          name="Usuários" path="/hermes/user" perm="user.get_all" />
      </ListItemMenu>}
    </List>
  )
};

export const secondaryListItems = (
  <React.Fragment>

  </React.Fragment>
);
